import {
  FiBriefcase,
  FiInbox,
  FiMonitor,
  FiSettings,
  FiShield,
  FiThumbsDown,
  FiThumbsUp,
  FiUser,
  FiDollarSign,
  FiAward,
  FiTrendingUp,
  FiBarChart2,
} from "react-icons/fi";
import {FileTextFilled } from "@ant-design/icons";
import { GiBookmark } from "react-icons/gi";

import { actions, hasPermission } from "../../services/security";

import InicioSection from "../../inicio/inicio-section";

const InicioPage = () => {
  const sections = [
    {
      title: "Inicio",
      links: [
        {
          title: "Plantillas",
          url: "/Plantillas",
          icon: <FileTextFilled />,
          visible: hasPermission(actions.PlantillaMasterDocVer),
        },
        {
          title: "Diccionario",
          url: "/Diccionario",
          icon: <GiBookmark />,
          visible: hasPermission(actions.DiccionarioVer),
        }
      ],
    },
    {
      title: "Seguridad",
      links: [
        {
          title: "Perfiles",
          url: "/perfiles",
          icon: <FiShield />,
          visible: hasPermission(actions.PerfilesVer),
        },
        {
          title: "Usuarios",
          url: "/usuarios",
          icon: <FiUser />,
          visible: hasPermission(actions.UsuariosVer),
        },
      ],
    },
  ];

  return (
    <div>
      {sections.map(
        (section, index) =>
          section.links.filter((x) => x.visible).length > 0 && (
            <InicioSection key={index} item={section} />
          )
      )}
    </div>
  );
};

export default InicioPage;
